import { useRouter } from '@repo/ui/hooks/use-router';
import { lazy, Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DendromapLoader } from '@repo/ui/components/dendromap-loader';

const CreateInventaireWizard = lazy(() =>
  import('@repo/ui/features/inventaires/implentation/create-inventaire-wizard').then((mod) => ({
    default: mod.CreateInventaireWizard,
  })),
);

export default function InventaireCreatePage() {
  const router = useRouter();
  const [searchParams] = useSearchParams();
  const rawType = searchParams.get('type')?.toLowerCase();
  const inventaireType =
    rawType === 'alignement' ? 'ALIGNEMENT' :
    rawType === 'epaysage'   ? 'EPAYSAGE'   :
    'ARBRE';

  return (
    <div className="w-full min-h-screen">
      <Suspense fallback={<DendromapLoader message="Chargement du formulaire..." />}>
        <CreateInventaireWizard
          inventaireType={inventaireType}
          onCancel={() => router.push('/admin/inventaires')}
        />
      </Suspense>
    </div>
  );
}
